import React, { FC, useState } from 'react';
import { addDataLayer } from 'src/shared/helpers';

import IconPlusCircle from 'src/shared/icons/accordion_plus.svg';
import IconCloseCircle from 'src/shared/icons/accordion_xmark.svg';
import styled from 'styled-components';

interface StyledAccordionProps {
    title: string;
    expandable?: boolean;
    iconAccordionClosed?: React.ReactNode;
    iconAccordionOpened?: React.ReactNode;
    children?: React.ReactNode;
    event?: string;
}

const StyledAccordion = styled.div<StyledAccordionProps>`
    display: flex;
    width: 100%;
    flex-direction: column;
`;

const HeaderAccordion = styled.div<{ expandable?: boolean }>`
    display: flex;
    font-weight: bold;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    ${(props) => props.expandable !== false && 'cursor: pointer;'}

    > label {
        color: ${(props) => props.theme.app.component.accordion.titleColor};
        font-size: 16px;
        width: calc(100% - 63px);
    }
    > svg {
        margin-left: 15px;
        cursor: pointer;
    }
`;

const ContentAccordion = styled.div<{ children?: React.ReactNode }>`
    width: calc(100% - 63px);
`;

const IconArrowDown = styled(IconPlusCircle)`
    width: 48px;
    height: 48px;
`;
const IconArrowUp = styled(IconCloseCircle)`
    width: 48px;
    height: 48px;
`;

export const Accordion = styled.div`
    font-family: ${(props) => props.theme.app.font};
    margin: 25px auto 0;
    text-align: left;
    color: ${(props) => props.theme.app.component.accordion.textItemColor};

    > div {
        padding: 15px 0;
        border-bottom: 1px solid ${(props) => props.theme.app.component.accordion.lineColor};
        &:last-child {
            border: none;
        }
    }

    a {
        color: ${(props) => props.theme.app.secondary};
    }
`;

const _AccordionItem: FC<StyledAccordionProps> = (props) => {
    // State
    const [expanded, setExpanded] = useState(false);

    function handlerOnPlus(event: string, title: string, action: string) {
        //TM4
        addDataLayer({
            event: event,
            category: event,
            action: action,
            label: title
        });
    }

    // Callback click button
    const onExpandCollapseClick = (title: string) => {
        if (props.event) {
            if (expanded) {
                handlerOnPlus(props.event, title, 'close');
            } else {
                handlerOnPlus(props.event, title, 'open');
            }
        }
        setExpanded(!expanded);
    };

    return (
        <StyledAccordion {...props}>
            <HeaderAccordion onClick={() => props.expandable !== false && onExpandCollapseClick(props.title)} className='header' expandable={props.expandable}>
                <label>{props.title}</label>
                {props.expandable !== false && !expanded && (props.iconAccordionClosed ? props.iconAccordionClosed : <IconArrowDown></IconArrowDown>)}
                {expanded && (props.expandable !== false && props.iconAccordionOpened ? props.iconAccordionOpened : <IconArrowUp></IconArrowUp>)}
            </HeaderAccordion>
            {(expanded || props.expandable === false) && <ContentAccordion className='content'>{props.children}</ContentAccordion>}
        </StyledAccordion>
    );
};

export const AccordionItem = styled(_AccordionItem)``;
